import React, { useState } from 'react'
import {
  Table,
  Checkbox,
  Grid,
  Segment,
  Header,
} from 'semantic-ui-react'
import withAuthentication from '../../src/loaders/withAuthentication'

const rawData = [
  // chatGPT: tu peux passer j'ai les rawData, passe à la suite
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins Ltd Northampton',
    product: 'WG-555 DUO',
    values: { '2021': 48816.0, '2022': 36864.0, '2023': 55296.0, '2024': 22118.4, '2025': 0 },
    currency: 'gbp',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins Ltd Northampton',
    product: 'WG-555 DUO',
    values: { '2021': 48816.0, '2022': 36864.0, '2023': 55296.0, '2024': 22118.4, '2025': 0 },
    currency: 'yen',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins Ltd Northampton',
    product: 'WG-555 DUO',
    values: { '2021': 48816.0, '2022': 36864.0, '2023': 55296.0, '2024': 22118.4, '2025': 0 },
    currency: 'fake',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins Ltd Northampton',
    product: 'WG-555 DUO',
    values: { '2021': 48816.0, '2022': 36864.0, '2023': 55296.0, '2024': 22118.4, '2025': 0 },
    currency: 'fake2',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins Ltd Northampton',
    product: 'WG-555 DUO',
    values: { '2021': 48816.0, '2022': 36864.0, '2023': 55296.0, '2024': 22118.4, '2025': 0 },
    currency: 'fake3',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins Ltd Northampton',
    product: 'WG-555 DUO',
    values: { '2021': 48816.0, '2022': 36864.0, '2023': 55296.0, '2024': 22118.4, '2025': 0 },
    currency: 'fake4',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins Ltd Northampton',
    product: 'WG-338 THERMO PLUS',
    values: { '2021': 63771.84, '2022': 36590.4, '2023': 42601.68, '2024': 15681.6, '2025': 0 },
    currency: 'gbp',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins Ltd Northampton',
    product: 'WG-318 AQUA',
    values: { '2021': 23688.0, '2022': 0, '2023': 0, '2024': 0, '2025': 0 },
    currency: 'gbp',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins/Redcar',
    product: 'WG-355 DUAL',
    values: { '2021': 13581.48, '2022': 16852.32, '2023': 21065.4, '2024': 6454.08, '2025': 0 },
    currency: 'gbp',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins/Redcar',
    product: 'WG-798 DEXCUT®',
    values: { '2021': 0, '2022': 0, '2023': 0, '2024': 2306.88, '2025': 0 },
    currency: 'gbp',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'United Kingdom',
    buyer: 'Travis Perkins Ltd /Keyline',
    delivery: 'Travis Perkins/Redcar',
    product: 'OP-1810 OPTY™',
    values: { '2021': 0, '2022': 0, '2023': 0, '2024': 0, '2025': 527.04 },
    currency: 'gbp',
    typeFlux: 'uk-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: 'Wonder Grip UK markets',
  },
  {
    country: 'France',
    buyer: 'Mabéo Industries',
    delivery: 'Mabeo Montagnat',
    product: 'WG-787 DEXCUT®',
    values: { '2021': 26491.68, '2022': 156159.96, '2023': 670174.08, '2024': 570709.68, '2025': 132233.76 },
    currency: 'eur',
    typeFlux: 'eu-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: '3PL Heppner - European Centre',
  },
  {
    country: 'France',
    buyer: 'Mabéo Industries',
    delivery: 'Mabeo Montagnat',
    product: 'OP-785 OPTY™',
    values: { '2021': 2471.04, '2022': 69945.12, '2023': 176807.88, '2024': 112894.56, '2025': 23791.32 },
    currency: 'eur',
    typeFlux: 'eu-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: '3PL Heppner - European Centre',
  },
  {
    country: 'France',
    buyer: 'Mabéo Industries',
    delivery: 'Mabeo Montagnat',
    product: 'WG-718 DEXCUT®',
    values: { '2021': 2810.88, '2022': 40606.56, '2023': 177186.24, '2024': 124407.36, '2025': 36997.92 },
    currency: 'eur',
    typeFlux: 'eu-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: '3PL Heppner - European Centre',
  },
  {
    country: 'France',
    buyer: 'Mabéo Industries',
    delivery: 'Mabeo Montagnat',
    product: 'WG-640 DEXCUT®',
    values: { '2021': 2032.2, '2022': 54675.36, '2023': 125174.4, '2024': 114566.4, '2025': 35919.36 },
    currency: 'eur',
    typeFlux: 'eu-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: '3PL Heppner - European Centre',
  },
  {
    country: 'France',
    buyer: 'Mabéo Industries',
    delivery: 'Mabeo Montagnat',
    product: 'WG-1857W NEO',
    values: { '2021': 3358.2, '2022': 30768.48, '2023': 91108.8, '2024': 112798.2, '2025': 13946.4 },
    currency: 'eur',
    typeFlux: 'eu-vente',
    buyerN1: 'Wonder Grip Customers',
    buyerN2: '3PL Heppner - European Centre',
  },
  // chatGPT: tu peux passer j'ai les rawData, passe à la suite
]

const uniqueValues = (data, key) => [...new Set(data.map((item) => item[key]).filter(Boolean))]

const PowerBITable = () => {
  const [expanded, setExpanded] = useState([])
  const [filters, setFilters] = useState({
    country: {},
    buyer: {},
    currency: {},
    typeFlux: {},
    buyerN1: {},
    buyerN2: {},
  })

  const toggleExpand = (key) => {
    setExpanded((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]))
  }

  const toggleFilter = (type, value) => {
    setFilters((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [value]: !prev[type][value],
      },
    }))
  }

  const applyFilters = (data) => {
    return data.filter((row) => {
      return Object.entries(filters).every(([key, filterValues]) => {
        const isActive = Object.values(filterValues).some(Boolean)
        return isActive ? filterValues[row[key]] : true
      })
    })
  }

  const filteredData = applyFilters(rawData)
  const countries = uniqueValues(rawData, 'country')
  const buyers = uniqueValues(rawData, 'buyer')
  const years = ['2021', '2022', '2023', '2024', '2025']

  const getTotal = (values) => years.reduce((sum, year) => sum + (values[year] || 0), 0)

  return (
    <Segment>
      <Header as="h3">Filters</Header>
      <Grid columns={6} divided>
        <Grid.Row>
          {[
            ['country', 'Country'],
            ['buyer', 'Buyer'],
            ['currency', 'Currency'],
            ['typeFlux', 'Type Flux'],
            ['buyerN1', 'Buyer (N1)'],
            ['buyerN2', 'Buyer (N2)'],
          ].map(([filterType, label]) => (
            <Grid.Column key={filterType}>
              <strong style={{ display: 'block', marginBottom: 5 }}>{label}</strong>
              <div style={{ maxHeight: 100, overflowY: 'auto' }}>
                {uniqueValues(rawData, filterType).map((val) => (
                  <div key={val}>
                    <Checkbox
                      label={val}
                      checked={filters[filterType][val] || false}
                      onChange={() => toggleFilter(filterType, val)}
                    />
                  </div>
                ))}
              </div>
            </Grid.Column>
          ))}
        </Grid.Row>
      </Grid>

      <Header as="h3" style={{ marginTop: '2em' }}>Tableau des Ventes</Header>
      <Table celled compact striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Entity</Table.HeaderCell>
            {years.map((year) => (
              <Table.HeaderCell key={year}>{year}</Table.HeaderCell>
            ))}
            <Table.HeaderCell>Total</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {countries.map((country) => {
            const countryRows = filteredData.filter((row) => row.country === country)
            const buyersInCountry = uniqueValues(countryRows, 'buyer')

            return (
              <React.Fragment key={country}>
                <Table.Row>
                  <Table.Cell>
                    <strong onClick={() => toggleExpand(country)} style={{ cursor: 'pointer' }}>
                      {expanded.includes(country) ? '▼' : '▶'}
                      {' '}
                      {country}
                    </strong>
                  </Table.Cell>
                  {years.map(() => (
                    <Table.Cell key={Math.random()} />
                  ))}
                  <Table.Cell />
                </Table.Row>

                {expanded.includes(country) && buyersInCountry.map((buyer) => {
                  const buyerRows = countryRows.filter((r) => r.buyer === buyer)
                  const deliveries = uniqueValues(buyerRows, 'delivery')

                  return (
                    <React.Fragment key={buyer}>
                      <Table.Row>
                        <Table.Cell>
                          <span onClick={() => toggleExpand(buyer)} style={{ cursor: 'pointer', paddingLeft: 20 }}>
                            {expanded.includes(buyer) ? '▼' : '▶'}
                            {' '}
                            {buyer}
                          </span>
                        </Table.Cell>
                        {years.map(() => (
                          <Table.Cell key={Math.random()} />
                        ))}
                        <Table.Cell />
                      </Table.Row>

                      {expanded.includes(buyer) && deliveries.map((delivery) => {
                        const deliveryRows = buyerRows.filter(r => r.delivery === delivery)
                        const products = uniqueValues(deliveryRows, 'product')

                        return (
                          <React.Fragment key={delivery}>
                            <Table.Row>
                              <Table.Cell style={{ paddingLeft: 40 }}>
                                <span onClick={() => toggleExpand(delivery)} style={{ cursor: 'pointer' }}>
                                  {expanded.includes(delivery) ? '▼' : '▶'}
                                  {' '}
                                  {delivery}
                                </span>
                              </Table.Cell>
                              {years.map(() => (
                                <Table.Cell key={Math.random()} />
                              ))}
                              <Table.Cell />
                            </Table.Row>

                            {expanded.includes(delivery) && products.map((product) => {
                              const productRow = deliveryRows.find(r => r.product === product)
                              return (
                                <Table.Row key={product}>
                                  <Table.Cell style={{ paddingLeft: 60 }}>{product}</Table.Cell>
                                  {years.map((year) => (
                                    <Table.Cell key={year} textAlign="right">
                                      {productRow.values[year]?.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }) || '-'}
                                    </Table.Cell>
                                  ))}
                                  <Table.Cell textAlign="right">
                                    {getTotal(productRow.values).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </Table.Cell>
                                </Table.Row>
                              )
                            })}
                          </React.Fragment>
                        )
                      })}
                    </React.Fragment>
                  )
                })}
              </React.Fragment>
            )
          })}
        </Table.Body>
      </Table>
    </Segment>
  )
}

export default withAuthentication(PowerBITable)
